import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
dayjs.extend(advancedFormat);
dayjs.extend(duration)
dayjs.extend(utc)
dayjs.extend(timezone)

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function formatDate(d, f='dddd M/D/YYYY') {
    return dayjs(d).format(f);
}

export function unixTimestamp(t) {
    return dayjs.unix(t).tz('America/New_York');
}

export function convertStatus(s) {
    switch (s) {
        case 'inCinemas':
            return 'In Theaters Now'
    }
    return capitalizeFirstLetter(s);
}

export function convertTime(t) {
    const oneMinuteAgo = dayjs().subtract(t, 'second')
    const dur = dayjs.duration(dayjs().diff(oneMinuteAgo))

    return dayjs.utc(dur.asMilliseconds()).format('H:mm') // "00:01:00"
}

export function urlify(u) {
    if(!u) return null;
    u=u.replaceAll(" ","-");
    u=u.replaceAll("''","");
    return u.toLowerCase();
}

export function rounder(number, dec=2) {
    number=parseFloat(number);
    return number.toFixed(dec);
}

export function truncateWords(text, wordLimit=20) {
    if (!text) return '';
    const words = text.trim().split(/\s+/);
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(' ') + '…';
}
